import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Col,
  Form,
  Input,
  Layout,
  Modal,
  message,
  Row,
  Select,
  Switch,
  Tag,
  Typography,
  Upload,
} from 'antd';
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import React from 'react';
import {
  IoCameraOutline,
  IoCheckmark,
  IoClose,
  IoLinkOutline,
  IoLogoFacebook,
  IoLogoGoogle,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoTwitter,
  IoLogoWhatsapp,
  IoLogoYoutube,
  IoSearch,
} from 'react-icons/io5';
import ReactInputMask from 'react-input-mask';
import { Link, Navigate } from 'react-router-dom';
import TableComponent from '../../../components/Table';
import {
  getToken,
  getUPLOADAPI,
  POST_API,
  POST_CATCH,
  setPath,
  titleWeb,
  verifyConfig,
} from '../../../services/api';
// CONTROLLER
import Page403 from '../../Controller/Page403';
import PageLoad from '../../Controller/PageLoad';

class AdminClienteForm extends React.Component {
  state = {
    _navigate: false,
    _loading: false,
    _screen: true,
    _dados: null,
    _modal: false,
    _params: window.location.href.split('/'),
    tags: [],
    vdoc: false,
    defaultValue: { ID: 0 },
    doc: false,
    // TABLE
    table_load: true,
    table_column: [],
    table_data: [],
    table_search: '',
    table_pagination: { current: 1, total: 0, limit: 10 },
    table_filter: {},
    table_sorter: null,
    table_select: [],
  };

  back = '/painel/clientes';

  routes = [
    { title: <Link to={this.back}>Clientes</Link> },
    { title: this.props.type === 'add' ? 'Adicionar' : 'Visualizar' },
  ];

  componentDidMount = () => {
    titleWeb('Clientes');
    setPath('client');
    if (this.props.type === 'add') {
      this.setState({
        defaultValue: { LOGIN: window.localStorage.getItem('CPFCNPJ') },
      });
      if (String(window.localStorage.getItem('CPFCNPJ')).length > 14)
        this.setState({ doc: true });
      this.setState({ _screen: false });
    } else if (this.props.type === 'edit') {
      this.onView();
    }
    this.onRenderColumns().then(() => this.onRenderData());
  };

  buscaCEP = async (val) => {
    var cep = String(val.target.value).replace('-', '');
    this.setState({ _screen: true });
    await fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then((rs) => rs.json())
      .then((res) => {
        if (res.erro) {
          message.warning('CEP inválido');
        } else {
          this.setState({
            defaultValue: {
              ...this.state.defaultValue,
              STREET: res.logradouro,
              DISTRICT: res.bairro,
              CITY: res.localidade,
              STATE: res.uf,
              CEP: cep,
            },
          });
        }
      })
      .catch(() => POST_CATCH())
      .finally(() => this.setState({ _screen: false }));
  };

  onView = async () => {
    await POST_API('/client/search.php', {
      token: getToken(),
      type: 'view',
      filter: JSON.stringify({ ID: this.state._params[5] }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        this.setState({ defaultValue: res.data, _screen: false });
        if (String(res.data.LOGIN).length > 14) this.setState({ doc: true });
      })
      .catch(() => POST_CATCH());
  };

  onSend = (values) => {
    this.setState({ _screen: true });
    POST_API('/client/self-pass.php', {
      token: getToken(),
      master: JSON.stringify(values),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      })
      .finally(() => this.setState({ _screen: false }));
  };

  onSendAccount = (values) => {
    this.setState({ _loading: true });
    POST_API('/client/saveall.php', {
      token: getToken(),
      master: JSON.stringify(this.state.defaultValue),
      tags: JSON.stringify(this.state.tags),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
          this.setState({ _navigate: true });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      })
      .finally(() => this.setState({ _loading: false }));
  };

  onChangePic = (value) => {
    if (value.file.response?.url) {
      this.setState({ _screen: true });
      POST_API('/client/save.php', {
        token: getToken(),
        master: JSON.stringify({
          AVATAR: value.file.response?.url,
          ID: this.state._params[5],
        }),
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            message.success({ content: res.msg, key: 'screen' });
          } else {
            message.warning({ content: res.msg, key: 'screen' });
          }
        })
        .catch(() => {
          message.error({
            content: 'Não foi possível estabelecer uma conexão com o sistema',
            key: 'screen',
          });
        })
        .finally(() => this.onView());
    }
  };

  onChangeName = (value) => {
    this.setState({ _screen: true });
    POST_API('/client/save.php', {
      token: getToken(),
      master: JSON.stringify({ NAME: value, ID: this.state._params[5] }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => {
        message.error({
          content: 'Não foi possível estabelecer uma conexão com o sistema',
          key: 'screen',
        });
      })
      .finally(() => this.onView());
  };

  downloadQRCode = async () => {
    const canvas = await html2canvas(document.getElementById('myqrcode'));
    const dataURL = canvas.toDataURL('image/png');
    downloadjs(dataURL, 'download.png', 'image/png');
  };

  onCopy = () => {
    window.navigator.clipboard.writeText(
      'https://jurisvip.adsolucoestecnologia.com.br'
    );
    message.success({ content: 'URL copiada', key: 'screen' });
  };

  onChangeField = (a, b) => {
    if (a.length > 0) {
      var name = a[0].name[0];
      var value = a[0].value;
      this.setState({
        defaultValue: {
          ...this.state.defaultValue,
          [name]: value,
        },
      });
    }
  };

  onRenderData = () => {
    this.setState({ table_load: true });
    setTimeout(async () => {
      POST_API('/tag/search.php', {
        token: getToken(),
        pagination: JSON.stringify(this.state.table_pagination),
        filter: JSON.stringify({ TYPE: 'C' }),
        sorter: JSON.stringify(this.state.table_sorter),
        search: this.state.table_search,
        type: this.props.type,
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            this.setState({
              table_data: res.data,
              table_pagination: {
                ...this.state.table_pagination,
                total: res.summary.QTDE,
              },
            });
          } else {
            message.error({ content: res.msg, key: 'screen' });
          }
        })
        .catch(() => POST_CATCH())
        .finally(() => this.setState({ table_load: false }));
    }, 500);
  };

  onRenderColumns = async () => {
    this.setState({
      table_column: [
        {
          title: 'Cod.',
          dataIndex: 'ID',
          key: 'tag.ID',
          width: 100,
          align: 'center',
          sorter: { compare: (a, b) => null },
          showSorterTooltip: false,
        },
        {
          title: 'Nome',
          dataIndex: 'NAME',
          key: 'tag.NAME',
          sorter: { compare: (a, b) => null },
          showSorterTooltip: false,
          render: (text, record) => (
            <Tag color={record.COLOR}>{record.NAME}</Tag>
          ),
        },
        {
          title: 'Ações',
          key: 'action',
          width: 80,
          render: (text, record) => (
            <Row className="table__actions" gutter={[4, 4]}>
              <Col>
                <Button
                  className="table__btn table__btn_view"
                  onClick={() =>
                    this.onSelect(record.ID, 'add', 'Selecionar Tag?', record)
                  }
                  shape="circle"
                  size="small"
                  title="Selecionar"
                  type="primary"
                >
                  <IoCheckmark size={14} />
                </Button>
              </Col>
            </Row>
          ),
        },
      ],
    });
  };

  onSelect = (ID, type, title, obj = null) => {
    var self = this;
    Modal.confirm({
      title,
      icon: <ExclamationCircleOutlined />,
      cancelText: 'Não',
      okText: 'Sim',
      onOk() {
        if (self.props.type === 'add') {
          var temp = self.state.tags;
          temp.push(obj);
          self.setState({ tags: temp, _modal: false });
          message.success({ content: 'Tag adicionada', key: 'screen' });
        } else {
          POST_API('/client_tag/save.php', {
            token: getToken(),
            CLIENT_ID: self.state.defaultValue.ID,
            TAG_ID: ID,
            type,
            selected: JSON.stringify(self.state.table_select),
          })
            .then((rs) => rs.json())
            .then((res) => {
              if (res.return) {
                message.success({ content: res.msg, key: 'screen' });
                if (type === 'add-select') self.setState({ table_select: [] });
                self.onView();
              } else {
                message.warning({ content: res.msg, key: 'screen' });
              }
            })
            .catch(() => {
              POST_CATCH();
            })
            .finally(() => self.setState({ _loading: false, _modal: false }));
        }
      },
      onCancel() {},
    });
  };

  onDelete = (ID, index = null) => {
    var self = this;
    Modal.confirm({
      title: 'Deletar tag?',
      icon: <ExclamationCircleOutlined />,
      cancelText: 'Não',
      okText: 'Sim',
      onOk() {
        if (self.props.type === 'add') {
          const temp = self.state.tags;
          temp.splice(index, 1);
          self.setState({ tags: temp, _modal: false });
          message.success({ content: 'Tag removida', key: 'screen' });
        } else {
          POST_API('/client_tag/del.php', {
            token: getToken(),
            ID,
            type: 'del',
          })
            .then((rs) => rs.json())
            .then((res) => {
              if (res.return) {
                message.success({ content: res.msg, key: 'screen' });
                self.onView();
              } else {
                message.warning({ content: res.msg, key: 'screen' });
              }
            })
            .catch(() => {
              POST_CATCH();
            })
            .finally(() => self.setState({ _loading: false, _modal: false }));
        }
      },
      onCancel() {},
    });
  };

  onTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      table_filter: filters,
      table_sorter: sorter,
    });
    this.onRenderData();
  };

  onPaginationChange = (page, size) => {
    this.setState({
      table_pagination: {
        ...this.state.table_pagination,
        current: page,
        limit: size,
      },
    });
    this.onRenderData();
  };

  onSearchChange = (e) => {
    this.setState({
      table_search: e.target.value,
    });
    this.onRenderData();
  };

  onChangePage = () => {
    this.setState({ table_data: [] });
    this.onRenderData();
  };

  onSelectTable = (selectedRowKeys, selectedRows) => {
    this.setState({ table_select: selectedRows });
  };

  buscaCliente = (e) => {
    POST_API('/client/search.php', {
      token: getToken(),
      type: 'view',
      filter: JSON.stringify({ CPFCNPJ: e.target.value }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.data) {
        } else {
          Modal.warning({
            title:
              'Cliente não encontrado no sistema. Deseja cadastrar como novo?',
          });
        }
      })
      .catch(() => POST_CATCH());
  };

  render = () => {
    if (this.state._navigate) return <Navigate to={this.back} />;
    if (!verifyConfig(`${this.props.per}.${this.props.type}`))
      return <Page403 />;

    return (
      <Layout>
        <Layout.Content className={'admin-container'}>
          <Row gutter={[8, 8]}>
            <Col span={18}>
              <Breadcrumb items={this.routes} />
            </Col>
            <Col
              span={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Link to={'..'}>
                <Button shape="round" size="small" type="primary">
                  Voltar
                </Button>
              </Link>
            </Col>
            {this.state._screen ? (
              <PageLoad />
            ) : (
              <>
                {this.props.type === 'add' ? (
                  <>
                    <Col md={24} xs={24}>
                      <Form
                        initialValues={this.state.defaultValue}
                        layout="vertical"
                        onFieldsChange={(a, b) => this.onChangeField(a, b)}
                        onFinish={this.onSendAccount}
                      >
                        <Button
                          className="fabbutton btn-primary"
                          htmlType="submit"
                          shape="circle"
                          size="large"
                        >
                          <IoCheckmark color="#FFF" size={22} />
                        </Button>
                        <Row gutter={[8, 8]}>
                          <Col span={24}>
                            <Card bordered size="small" title="Dados">
                              <Row gutter={[16, 0]}>
                                <Col md={6} xs={24}>
                                  <Form.Item
                                    label={this.state.doc ? 'CNPJ' : 'CPF'}
                                    name="LOGIN"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input readOnly type="text" />
                                    {/* <ReactInputMask readOnly className="ant-input css-dev-only-do-not-override-w8mnev css-w8mnev" placeholder={this.state.doc ? 'CNPJ' : 'CPF'} mask={this.state.doc ? '99.999.999/9999-99' : '999.999.999-99'} /> */}
                                  </Form.Item>
                                  {/* <Switch disabled checked={this.state.doc} unCheckedChildren="CPF" checkedChildren="CNPJ" onChange={(v) => this.setState({doc: v})} style={{position: 'absolute', right: 13, top: 35}} /> */}
                                </Col>
                                <Col md={14} xs={24}>
                                  <Form.Item hidden name="ID">
                                    <Input type="text" />
                                  </Form.Item>
                                  <Form.Item
                                    label="Nome Completo"
                                    name="NAME"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>

                                <Col md={4} xs={24}>
                                  <Form.Item
                                    label="Data Nascimento"
                                    name="BIRTHDAY"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input type="date" />
                                  </Form.Item>
                                </Col>
                                <Col md={6} xs={24}>
                                  <Form.Item label="Gênero" name="GENDER">
                                    <Select>
                                      <Select.Option value="F">
                                        Feminino
                                      </Select.Option>
                                      <Select.Option value="M">
                                        Masculino
                                      </Select.Option>
                                      <Select.Option value="O">
                                        Outros
                                      </Select.Option>
                                      <Select.Option value="NA">
                                        Prefiro não informar
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col md={6} xs={24}>
                                  <Form.Item
                                    label="Estado Civil"
                                    name="MARITAL_STATUS"
                                  >
                                    <Select>
                                      <Select.Option value="S">
                                        Solteiro
                                      </Select.Option>
                                      <Select.Option value="C">
                                        Casado
                                      </Select.Option>
                                      <Select.Option value="D">
                                        Divorciado
                                      </Select.Option>
                                      <Select.Option value="V">
                                        Viúvo
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col md={6} xs={24}>
                                  <Form.Item label="Profissão" name="FUNCTION">
                                    <Input
                                      placeholder="Exemplo: Prefeitura, Polícia Militar, Supermercado."
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={6} xs={24}>
                                  <Form.Item
                                    label="Local de Trabalho"
                                    name="WORKPLACE"
                                  >
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={12} xs={24}>
                                  <Form.Item label="Apresentação" name="DESC">
                                    <Input.TextArea
                                      maxLength={1000}
                                      rows={4}
                                      showCount
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={12} xs={24}>
                                  <Form.Item label="Observações" name="ABOUT">
                                    <Input.TextArea
                                      maxLength={1000}
                                      rows={4}
                                      showCount
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Col span={24}>
                            <Card bordered size="small" title="Endereço">
                              <Row gutter={[16, 0]}>
                                <Col md={6} xs={24}>
                                  <Form.Item label="CEP" name="CEP">
                                    <ReactInputMask
                                      mask={'99999-999'}
                                      maskChar={''}
                                      maxLength={9}
                                      onBlur={this.buscaCEP}
                                    >
                                      {(props) => <Input {...props} />}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={14} xs={24}>
                                  <Form.Item label="Endereço" name="STREET">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={4} xs={24}>
                                  <Form.Item label="Número" name="NUMBER">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={10} xs={24}>
                                  <Form.Item label="Bairro" name="DISTRICT">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={10} xs={24}>
                                  <Form.Item label="Cidade" name="CITY">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={4} xs={24}>
                                  <Form.Item label="UF" name="STATE">
                                    <Input maxLength={2} type="text" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Col span={24}>
                            <Card bordered size="small" title="Contato">
                              <Row gutter={[16, 0]}>
                                <Col md={16} xs={24}>
                                  <Form.Item
                                    label="E-mail"
                                    name="EMAIL"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input
                                      addonBefore={<IoLogoGoogle />}
                                      type="email"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item
                                    label="Whatsapp"
                                    name="WHATSAPP"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <ReactInputMask
                                      mask={'+55 (99) 99999-9999'}
                                      maskChar={''}
                                      maxLength={19}
                                      value={this.state.defaultValue?.WHATSAPP}
                                    >
                                      {(props) => (
                                        <Input
                                          {...props}
                                          addonBefore={<IoLogoWhatsapp />}
                                        />
                                      )}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={16} xs={24}>
                                  <Form.Item label="Outro e-mail" name="EMAIL2">
                                    <Input
                                      addonBefore={<IoLogoGoogle />}
                                      type="email"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Celular" name="PHONE">
                                    <ReactInputMask
                                      mask={'+55 (99) 99999-9999'}
                                      maskChar={''}
                                      maxLength={21}
                                      value={this.state.defaultValue?.PHONE}
                                    >
                                      {(props) => (
                                        <Input
                                          {...props}
                                          addonBefore={<IoLogoWhatsapp />}
                                        />
                                      )}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Instagram" name="INSTAGRAM">
                                    <Input
                                      addonBefore={<IoLogoInstagram />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Facebook" name="FACEBOOK">
                                    <Input
                                      addonBefore={<IoLogoFacebook />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Twitter" name="TWITTER">
                                    <Input
                                      addonBefore={<IoLogoTwitter />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="LinkedIn" name="LINKEDIN">
                                    <Input
                                      addonBefore={<IoLogoLinkedin />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Youtube" name="YOUTUBE">
                                    <Input
                                      addonBefore={<IoLogoYoutube />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Site" name="SITE">
                                    <Input
                                      addonBefore={<IoLinkOutline />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                    <Col span={24}>
                      <Card bordered size="small" title="Tags">
                        <Input
                          addonAfter={
                            <Button
                              onClick={() => this.setState({ _modal: true })}
                              shape="circle"
                              size="small"
                              type="link"
                            >
                              <IoSearch color="black" size={20} />
                            </Button>
                          }
                          disabled
                          placeholder="Escolher tag"
                        />
                        <Row>
                          {this.state.tags.map((v, i) => (
                            <Col
                              className="tag"
                              style={{ backgroundColor: v.COLOR }}
                            >
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  width: 10,
                                  height: 10,
                                }}
                                type="link"
                              >
                                <IoClose
                                  color="white"
                                  onClick={() => this.onDelete(v.ID, i)}
                                  size={18}
                                />
                              </Button>
                              {v.NAME}
                            </Col>
                          ))}
                        </Row>
                      </Card>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md={8} xs={24}>
                      <Row gutter={[8, 8]}>
                        <Col span={24}>
                          <Card
                            bordered
                            size="small"
                            style={{ paddingTop: 20 }}
                          >
                            <Row
                              align={'middle'}
                              justify="center"
                              style={{ flexDirection: 'column' }}
                            >
                              <Avatar
                                shape="circle"
                                size={200}
                                src={this.state.defaultValue.AVATAR}
                                style={{ marginBottom: 12 }}
                              />
                              <Typography
                                className={'admin-profile-name'}
                                editable={{
                                  tooltip: false,
                                  onChange: this.onChangeName,
                                }}
                              >
                                {this.state.defaultValue.NAME}
                              </Typography>
                              <Tag color={this.state.defaultValue.STATUS_COLOR}>
                                {this.state.defaultValue.CREDENTIAL_TYPE_NAME}
                              </Tag>
                            </Row>
                          </Card>
                        </Col>
                        <Col span={24}>
                          <Card bordered size="small" title="Tags">
                            <Input
                              addonAfter={
                                <Button
                                  onClick={() =>
                                    this.setState({ _modal: true })
                                  }
                                  shape="circle"
                                  size="small"
                                  type="link"
                                >
                                  <IoSearch color="black" size={20} />
                                </Button>
                              }
                              disabled
                              placeholder="Escolher tag"
                            />
                            <Row>
                              {this.state.defaultValue?.TAGS.map((v, i) => (
                                <Col
                                  className="tag"
                                  style={{ backgroundColor: v.TAG_COLOR }}
                                >
                                  <Button
                                    shape="circle"
                                    size="small"
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      width: 10,
                                      height: 10,
                                    }}
                                    type="link"
                                  >
                                    <IoClose
                                      color="white"
                                      onClick={() => this.onDelete(v.ID)}
                                      size={18}
                                    />
                                  </Button>
                                  {v.TAG_NAME}
                                </Col>
                              ))}
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={16} xs={24}>
                      <Form
                        initialValues={this.state.defaultValue}
                        layout="vertical"
                        onFieldsChange={(a, b) => this.onChangeField(a, b)}
                        onFinish={this.onSendAccount}
                      >
                        <Row gutter={[8, 8]}>
                          <Col span={24}>
                            <Card bordered size="small" title="Perfil Público">
                              <Row gutter={[16, 0]}>
                                <Form.Item hidden name="ID">
                                  <Input type="text" />
                                </Form.Item>
                                <Col md={18} xs={24}>
                                  <Form.Item
                                    label={this.state.doc ? 'CNPJ' : 'CPF'}
                                    name="LOGIN"
                                  >
                                    <ReactInputMask
                                      disabled
                                      mask={
                                        this.state.doc
                                          ? '99.999.999/9999-99'
                                          : '999.999.999-99'
                                      }
                                      maskChar={''}
                                      maxLength={this.state.doc ? 18 : 14}
                                      placeholder={
                                        this.state.doc ? 'CNPJ' : 'CPF'
                                      }
                                    >
                                      {(props) => <Input {...props} />}
                                    </ReactInputMask>
                                  </Form.Item>
                                  <Switch
                                    checked={this.state.doc}
                                    checkedChildren="CNPJ"
                                    disabled
                                    onChange={(v) => this.setState({ doc: v })}
                                    style={{
                                      position: 'absolute',
                                      right: 13,
                                      top: 35,
                                    }}
                                    unCheckedChildren="CPF"
                                  />
                                </Col>
                                <Col md={6} xs={24}>
                                  <Form.Item
                                    label="Data Nascimento"
                                    name="BIRTHDAY"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input disabled type="date" />
                                  </Form.Item>
                                </Col>
                                <Col md={10} xs={24}>
                                  <Form.Item label="Gênero" name="GENDER">
                                    <Select>
                                      <Select.Option value="F">
                                        Feminino
                                      </Select.Option>
                                      <Select.Option value="M">
                                        Masculino
                                      </Select.Option>
                                      <Select.Option value="O">
                                        Outros
                                      </Select.Option>
                                      <Select.Option value="NA">
                                        Prefiro não informar
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col md={14} xs={24}>
                                  <Form.Item
                                    label="Estado Civil"
                                    name="MARITAL_STATUS"
                                  >
                                    <Select>
                                      <Select.Option value="S">
                                        Solteiro
                                      </Select.Option>
                                      <Select.Option value="C">
                                        Casado
                                      </Select.Option>
                                      <Select.Option value="D">
                                        Divorciado
                                      </Select.Option>
                                      <Select.Option value="V">
                                        Viúvo
                                      </Select.Option>
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col md={12} xs={24}>
                                  <Form.Item label="Profissão" name="FUNCTION">
                                    <Input
                                      placeholder="Exemplo: Prefeitura, Polícia Militar, Supermercado."
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={12} xs={24}>
                                  <Form.Item
                                    label="Local de Trabalho"
                                    name="WORKPLACE"
                                  >
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={24} xs={24}>
                                  <Form.Item label="Apresentação" name="DESC">
                                    <Input.TextArea
                                      maxLength={1000}
                                      rows={4}
                                      showCount
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={24} xs={24}>
                                  <Form.Item label="Sobre" name="ABOUT">
                                    <Input.TextArea
                                      maxLength={1000}
                                      rows={4}
                                      showCount
                                      type="text"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Col span={24}>
                            <Card bordered size="small" title="Endereço">
                              <Row gutter={[16, 0]}>
                                <Col md={6} xs={24}>
                                  <Form.Item label="CEP" name="CEP">
                                    <ReactInputMask
                                      mask={'99999-999'}
                                      maskChar={''}
                                      maxLength={9}
                                      onBlur={this.buscaCEP}
                                    >
                                      {(props) => <Input {...props} />}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={14} xs={24}>
                                  <Form.Item label="Endereço" name="STREET">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={4} xs={24}>
                                  <Form.Item label="Número" name="NUMBER">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={10} xs={24}>
                                  <Form.Item label="Bairro" name="DISTRICT">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={10} xs={24}>
                                  <Form.Item label="Cidade" name="CITY">
                                    <Input type="text" />
                                  </Form.Item>
                                </Col>
                                <Col md={4} xs={24}>
                                  <Form.Item label="UF" name="STATE">
                                    <Input maxLength={2} type="text" />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Col span={24}>
                            <Card bordered size="small" title="Contato">
                              <Row gutter={[16, 0]}>
                                <Col md={16} xs={24}>
                                  <Form.Item
                                    label="E-mail"
                                    name="EMAIL"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <Input
                                      addonBefore={<IoLogoGoogle />}
                                      type="email"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item
                                    label="Whatsapp"
                                    name="WHATSAPP"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Campo Obrigatório',
                                      },
                                    ]}
                                  >
                                    <ReactInputMask
                                      mask={'+55 (99) 99999-9999'}
                                      maskChar={''}
                                      maxLength={19}
                                      value={this.state.defaultValue?.WHATSAPP}
                                    >
                                      {(props) => (
                                        <Input
                                          {...props}
                                          addonBefore={<IoLogoWhatsapp />}
                                        />
                                      )}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={16} xs={24}>
                                  <Form.Item label="Outro e-mail" name="EMAIL2">
                                    <Input
                                      addonBefore={<IoLogoGoogle />}
                                      type="email"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Celular" name="PHONE">
                                    <ReactInputMask
                                      mask={'+55 (99) 99999-9999'}
                                      maskChar={''}
                                      maxLength={21}
                                      value={this.state.defaultValue?.PHONE}
                                    >
                                      {(props) => (
                                        <Input
                                          {...props}
                                          addonBefore={<IoLogoWhatsapp />}
                                        />
                                      )}
                                    </ReactInputMask>
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Instagram" name="INSTAGRAM">
                                    <Input
                                      addonBefore={<IoLogoInstagram />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Facebook" name="FACEBOOK">
                                    <Input
                                      addonBefore={<IoLogoFacebook />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Twitter" name="TWITTER">
                                    <Input
                                      addonBefore={<IoLogoTwitter />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="LinkedIn" name="LINKEDIN">
                                    <Input
                                      addonBefore={<IoLogoLinkedin />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Youtube" name="YOUTUBE">
                                    <Input
                                      addonBefore={<IoLogoYoutube />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col md={8} xs={24}>
                                  <Form.Item label="Site" name="SITE">
                                    <Input
                                      addonBefore={<IoLinkOutline />}
                                      type="url"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          </Col>
                          <Button
                            className="fabbutton btn-primary"
                            htmlType="submit"
                            shape="circle"
                            size="large"
                          >
                            <IoCheckmark color="#FFF" size={22} />
                          </Button>
                        </Row>
                      </Form>
                    </Col>
                  </>
                )}
              </>
            )}
          </Row>
          <Modal
            footer={false}
            onCancel={() => this.setState({ _modal: false })}
            open={this.state._modal}
            title="Lista de Tags"
          >
            <Row>
              <Col
                span={24}
                style={{ display: 'flex', justifyContent: 'flex-end' }}
              >
                {/* { this.state.table_select.length > 0 ? <Button onClick={() => this.onSelect(null, 'add-select', 'Selecionar Tags?')} type="default" size="small" shape="round" className="sys-btn-default sys-btn-small"style={{marginRight: 5}}>Escolher Selecionados ({this.state.table_select.length})</Button> : null } */}
                {verifyConfig('trf.add') ? (
                  <Link target="_blank" to={'/painel/tags/add'}>
                    <Button
                      className="sys-btn-primary sys-btn-small"
                      shape="round"
                      size="small"
                      type="primary"
                    >
                      Novo
                    </Button>
                  </Link>
                ) : null}
              </Col>
              <Col span={24}>
                <TableComponent
                  _columns={this.state.table_column}
                  _data={this.state.table_data}
                  _loading={this.state.table_load}
                  _onChangePagination={this.onPaginationChange}
                  _onChangeSearch={this.onSearchChange}
                  _onChangeTable={this.onTableChange}
                  _pagination={this.state.table_pagination}
                  _search={this.state.table_search}
                />
              </Col>
            </Row>
          </Modal>
        </Layout.Content>
      </Layout>
    );
  };
}

export default AdminClienteForm;
